import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import { OLAF } from 'HubStyleTokens/colors';
import { mediaQueries } from 'developer-docs-shared-components/utils/mediaQueries';
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import { getStartedNavConfig } from '../../config/nav/getStarted/getStarted';
import { queensFontFamily } from './QueensFontStyles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HeaderSubText = styled(FormattedMessage).withConfig({
  displayName: "DeveloperDocsHeader__HeaderSubText",
  componentId: "iaff28-0"
})(["color:", ";font-size:24px;font-weight:400;", "{font-size:16px;text-align:center;}"], OLAF, mediaQueries.belowTablet);
const StyledDivWithGap = styled.div.withConfig({
  displayName: "DeveloperDocsHeader__StyledDivWithGap",
  componentId: "iaff28-1"
})(["", "{padding:64px 30px;flex:500 0 500px;justify-content:center;max-width:1000px;}display:flex;gap:40px;flex-direction:column;", "{align-items:center;}"], mediaQueries.aboveTablet, mediaQueries.belowTablet);
const HeaderButton = styled(UIRouterButton).withConfig({
  displayName: "DeveloperDocsHeader__HeaderButton",
  componentId: "iaff28-2"
})(["width:fit-content;", "{margin-bottom:50px;}"], mediaQueries.aboveTablet);

/* @bend-expect no-styled-foundations-components */
const StyledH1 = styled(Text).withConfig({
  displayName: "DeveloperDocsHeader__StyledH1",
  componentId: "iaff28-3"
})(["", " color:", ";font-size:64px;font-weight:500;margin-bottom:unset;", "{font-size:40px;text-align:center;margin-top:20px;}"], queensFontFamily, OLAF, mediaQueries.belowTablet);
export const DeveloperDocsHeader = () => {
  return /*#__PURE__*/_jsxs(StyledDivWithGap, {
    children: [/*#__PURE__*/_jsx(StyledH1, {
      as: "h1",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "developer-docs-ui.mainLandingPage.header.header"
      })
    }), /*#__PURE__*/_jsx(HeaderSubText, {
      message: "developer-docs-ui.mainLandingPage.header.subText"
    }), /*#__PURE__*/_jsx(HeaderButton, {
      to: `${getStartedNavConfig().commonPath}`,
      use: "primary",
      size: "medium",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "developer-docs-ui.mainLandingPage.header.buttonText"
      })
    })]
  });
};